import React, {createContext, useCallback, useContext, useState} from 'react';
import {initialFilter} from "../../../Accounting/Pages/invoices/InvoicesUIHelpers";
import {isEqual, isFunction} from "lodash";


const NoticesUIContext = createContext();


export function useNoticesUIContext() {
    return useContext(NoticesUIContext);
}


export function NoticesUIProvider({noticesUIEvents, children}){

    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [ids, setIds] = useState([]);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);
    
    
    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        ids,
        setIds,
        
        newNoticeButtonClick: noticesUIEvents.newNoticeButtonClick,
        viewNoticeButtonClick: noticesUIEvents.viewNoticeButtonClick,
        deleteNoticeButtonClick: noticesUIEvents.deleteNoticeButtonClick
        
    }
    
    return <NoticesUIContext.Provider value={value}>{children}</NoticesUIContext.Provider>
    
}